import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareArrowBottomRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconSquareArrowBottomRight"><Path d="M20.5 9.5V3.5L3.5 3.5L3.5 20.5H9.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20.5 14.5V20.5H14.5" stroke="currentColor" strokeLinecap="square"/><Path d="M20 20L11.5 11.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconSquareArrowBottomRight;
